import { useContext, useEffect, useMemo, useState } from "react";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { ErrorPanel } from "../../components/error-panel";
import { ApiContext } from "../../context/api.provider";
import { AuthContext } from "../../context/auth.provider";
import { useNonce } from "../../hooks";
import { VOTING_ROUND_MODE } from "../../domain/election";
import { MainLayout } from "../../layout/main-layout";
import { CenterLoading } from "../../components/center-loading";
import { DEMOS } from "../../const/demo";
import { ElectionProvider } from "./election.provider";
import { DemoElectionProvider } from "./demo.provider";




export const ElectionLayout = () => {
  const { voter } = useContext(AuthContext);
  const { fetch } = useContext(ApiContext);

  const [election, setElection] = useState<any>(null);

  useEffect(() => {
    fetch({
      url: "/election"
    }).then(res => {
      setElection(res.data);
    });
  }, [voter]);


  if (!voter) {
    return <ErrorPanel text="Must have voter" source="ElectionPage" />;
  }

  if (!election) {
    return <CenterLoading />
  }

  return (
    <ElectionProvider
      election={election}
      voter={voter}
    >
      <MainLayout
        style_config={election.style_config}
        logoSmUrl={election.logo_sm_url}
        preview={election.mode === VOTING_ROUND_MODE.PREVIEW}
      >
        <Outlet />
      </MainLayout>
    </ElectionProvider>
  );
};




export const DemoElectionLayout = () => {
  const navigate = useNavigate();

  const { election_id } = useParams();

  const election = useMemo(() => {
    if (!election_id) {
      navigate("/");
      return;
    }
    const demo = DEMOS[election_id];
    if (!demo) {
      return null;
    }
    return demo.payload;
  }, [election_id])

  if (!election) {
    return <ErrorPanel source="DemoElectionLayout" text={`Invalid demo key: ${election_id}`} />
  }

  return (
    <DemoElectionProvider
      election={election}
    >
      <MainLayout
        style_config={election.style_config}
        logoSmUrl={election.logo_sm_url}
        preview={election.mode === VOTING_ROUND_MODE.PREVIEW}
      >
        <Outlet />
      </MainLayout>
    </DemoElectionProvider>
  );
};

